<ng-container *ngIf="value" i18n>Yes</ng-container>
<ng-container *ngIf="!value" i18n>No</ng-container>
